<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{
      caixaAlta(limitar(profissional.nome, 30))
    }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Número do conselho</strong></td>
            <td>{{ profissional.numeroConselho }}</td>
          </tr>
          <tr>
            <td><strong>Especialidades</strong></td>
            <td>
              <button
                data-test-id="button-exibiralertavaloressimples-1"
                class="btn btn-xs btn-link"
                @click="
                  exibirAlertaValoresSimples(
                    'Especialidades',
                    profissional.especialidade
                  )
                "
              >
                Ver todas
              </button>
            </td>
          </tr>
          <tr>
            <td><strong>Unidades</strong></td>
            <td>
              <button
                data-test-id="button-exibiralertavaloressimples-2"
                class="btn btn-xs btn-link"
                @click="
                  exibirAlertaValoresSimples('Unidades', profissional.unidade)
                "
              >
                Ver todas
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          data-test-id="link-auto-3"
          :to="'/profissional/cadastro/' + profissional._id"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" /> Editar
        </RouterLink>
        <RouterLink
          data-test-id="link-auto-4"
          :to="'/profissional/' + profissional._id + '/agendamentos'"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-calendar" /> Ver agendamentos
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'ProfissionalFicha',
  mixins: [alertaMixin],
  props: {
    profissional: {
      type: Object,
      required: true,
      validator: (value) => {
        return value && value._id
      },
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
